import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object().shape({
  supplier_name: yup.string().required("Supplier name is required"),
  supplier_email: yup
    .string()
    .email("Invalid email address")
    .required("Supplier email is required")
    .max(40, "Maximum of 30 characters is allowed"),
});

export const useValidation = ({ ...params }) => {
  return useForm({
    resolver: yupResolver(schema),
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      ...params,
    },
  });
};
